export class Touch {
  constructor() {
    this.enabled = false
    this.stage = null
  }

  getPosition(event) {
    let clientX = 0
    let clientY = 0

    if (event instanceof MouseEvent) {
      clientX = event.clientX
      clientY = event.clientY
    } else {
      const { touches, changedTouches } = event
      let touch = touches

      if (changedTouches.length) {
        touch = changedTouches
      }

      if (touch.length) {
        clientX = touch[0].clientX
        clientY = touch[0].clientY
      }
    }

    return {
      x: clientX,
      y: clientY,
    }
  }

  getElementAt(x, y) {
    const children = this.stage.getChildrenByPosition(x, y)
    if (children.length) {
      const core = children.pop()
      return core.element
    }
    return null
  }

  enable(stage) {
    if (this.enabled) {
      return
    }
    this.stage = stage

    const evt = event => {
      const eventPosition = this.getPosition(event)
      let touchedElement = this.getElementAt(eventPosition.x, eventPosition.y)

      while (!touchedElement.__tagRoot) {
        touchedElement = touchedElement.__parent
      }

      this.stage.application.focusBottomUpEvent(['_handleTouch'], touchedElement)
      this.stage.application.updateFocusPath()
    }

    document.addEventListener('touchstart', evt)
    document.addEventListener('mousedown', evt)

    this.enabled = true
  }
}
